import { render, staticRenderFns } from "./Phoenix.vue?vue&type=template&id=f6b5d15a&"
import script from "./Phoenix.vue?vue&type=script&lang=js&"
export * from "./Phoenix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports